import { useEffect, useState } from 'react';

import { EXIT_DELAY_IN_SECONDS } from '1_components/Transitition/settings';
import useAudioRoutingStore from 'state/audioRoutingStore';

const useTotalAudioDuration = () => {
  const { audioChunks } = useAudioRoutingStore();
  const [totalDuration, setTotalDuration] = useState<number>(0);
  const [durations, setDurations] = useState<number[]>([]);

  useEffect(() => {
    if (audioChunks && audioChunks.length > 0) {
      const audioElements = audioChunks.map(chunk => {
        const audio = new Audio(chunk.audioUrl);
        return audio;
      });

      Promise.all(
        audioElements.map(audio => {
          return new Promise<number>(resolve => {
            audio.addEventListener('loadedmetadata', () => {
              resolve(audio.duration);
            });
          });
        })
      ).then(durations => {
        const total_audio_duration = durations.reduce(
          (acc, duration) => acc + duration,
          0
        );
        const total_transition_delays =
          EXIT_DELAY_IN_SECONDS * audioChunks.length;

        const combinedTotal = total_audio_duration + total_transition_delays;

        setTotalDuration(combinedTotal);
        setDurations(
          durations.map(duration => duration + EXIT_DELAY_IN_SECONDS)
        );
      });
    }
  }, [audioChunks]);

  return { totalDuration, durations };
};

export default useTotalAudioDuration;
